const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787'

interface ApiResponse<T = unknown> {
  success: boolean
  data?: T
  error?: {
    code: string
    message: string
  }
}

export async function apiRequest<T>(
  endpoint: string,
  options: RequestInit = {}
): Promise<ApiResponse<T>> {
  try {
    const response = await fetch(`${API_URL}${endpoint}`, {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    })

    const data = await response.json()
    return data
  } catch (error) {
    console.error('API Error:', error)
    return {
      success: false,
      error: {
        code: 'NETWORK_ERROR',
        message: 'Unable to connect to the server. Please try again.',
      },
    }
  }
}

export interface TrackingContext {
  page_url: string
  referrer: string
  utm_source: string
  utm_medium: string
  utm_campaign: string
  utm_term: string
  utm_content: string
  // Assessment-specific tracking
  assessment_type?: string
  assessment_title?: string
}

export interface ContactFormData {
  firstName: string
  lastName: string
  email: string
  phone: string
  company: string
  industry: string
  services: string[]
  message: string
  context?: TrackingContext
}

export async function submitContactForm(data: ContactFormData) {
  return apiRequest('/api/contact', {
    method: 'POST',
    body: JSON.stringify(data),
  })
}

export interface QuoteRequestData {
  firstName: string
  lastName: string
  email: string
  phone: string
  company: string
  industry: string
  employeeCount: string
  currentSolution: string
  services: string[]
  timeline: string
  budget: string
  message: string
}

export async function submitQuoteRequest(data: QuoteRequestData) {
  return apiRequest('/api/quote', {
    method: 'POST',
    body: JSON.stringify(data),
  })
}

